import { render } from "./NavLink.vue?vue&type=template&id=337232c2"
import script from "./NavLink.vue?vue&type=script&setup=true&lang=js"
export * from "./NavLink.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/NavLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "337232c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('337232c2', __exports__)) {
    api.reload('337232c2', __exports__)
  }
  
  module.hot.accept("./NavLink.vue?vue&type=template&id=337232c2", () => {
    api.rerender('337232c2', render)
  })

}


export default __exports__